import { CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    external?: boolean;
    text?: any;
    url: string;
};

export const SeeAllLink = ({ external = false, text = '', url = '' }: Props) => {
    const externalProps = external
        ? {
              rel: 'noopener',
              target: '_blank',
          }
        : {};

    return (
        <Link
            {...externalProps}
            className="group flex items-center xsMax:ml-xs"
            href={url || '#'}
        >
            <BodySecondary color="secondary">
                {text || (
                    <FormattedMessage
                        id="see_all"
                        key="see_all"
                    />
                )}
            </BodySecondary>
            <CaretRight
                className="inline-block text-text-secondary"
                size="xs"
            />
        </Link>
    );
};
